var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTWMergeContext } from '@marketing/TWMergeContext';
import { useEffect, useRef, useState } from 'react';
import lerp from '@utils/lerp';
function Tumbler(_a) {
    var text = _a.text, options = _a.options, className = _a.className;
    var twMerge = useTWMergeContext().twMerge;
    var _b = options || {}, _c = _b.lineHeight, lineHeight = _c === void 0 ? 48 : _c, _d = _b.radius, radius = _d === void 0 ? 0.5 : _d, _e = _b.mask, mask = _e === void 0 ? 0.5 : _e, _f = _b.period, period = _f === void 0 ? 0.15 : _f, _g = _b.steepness, steepness = _g === void 0 ? 0.25 : _g, _h = _b.spinForce, spinForce = _h === void 0 ? 0.5 : _h;
    var shouldAnimateRef = useRef(true);
    var _j = useState([0, 0, 0]), scaleValues = _j[0], setScaleValues = _j[1];
    var _k = useState([0, 0, 0]), translateValues = _k[0], setTranslateValues = _k[1];
    var numberOfSides = text.length;
    var minRadius = 0.1;
    var maxRadius = 1.25;
    var interpolatedRadius = lerp(minRadius, maxRadius, Number(radius));
    var minOpacityMask = -5;
    var maxOpacityMask = 3;
    var interpolatedOpacityMask = lerp(minOpacityMask, maxOpacityMask, 1 - Number(mask));
    var minPeriod = 0.1;
    var maxPeriod = 2;
    var interpolatedPeriod = lerp(minPeriod, maxPeriod, Number(period));
    var minSpinForce = 0;
    var maxSpinForce = 10;
    var interpolatedSpinForce = lerp(minSpinForce, maxSpinForce, Number(spinForce));
    var minSteepness = 1;
    var maxSteepness = 3;
    var interpolatedSteepness = Math.floor(lerp(minSteepness, maxSteepness, Number(steepness)));
    var cylinderRadius = !isNaN(radius) ? interpolatedRadius : 0.5 * numberOfSides;
    var opacityMask = !isNaN(mask) ? interpolatedOpacityMask : -0.4 * numberOfSides;
    function step(time, steepness) {
        if (steepness === 0) {
            return time - Math.sin(time);
        }
        else {
            return step(time - Math.sin(time), steepness - 1);
        }
    }
    function curveTransform(time, index, rotationOffset) {
        if (rotationOffset === void 0) { rotationOffset = 0; }
        return Math.cos(time + (index * 2 * Math.PI) / numberOfSides - rotationOffset);
    }
    function animate(time) {
        if (shouldAnimateRef.current) {
            var steppedTime = step(time / 1000 / interpolatedPeriod, interpolatedSteepness);
            var anglePerSide = (2 * Math.PI) / numberOfSides;
            var angleToSpin = anglePerSide * (numberOfSides + 1);
            var curveScale = angleToSpin + 2 * Math.PI * interpolatedSpinForce;
            var scaledTime_1 = (steppedTime * curveScale) / (2 * Math.PI);
            var scale = text.map(function (_, index) { return curveTransform(scaledTime_1, index); });
            var translate = text.map(function (_, index) { return curveTransform(scaledTime_1, index, Math.PI / 2) * cylinderRadius; });
            setScaleValues(scale);
            setTranslateValues(translate);
            requestAnimationFrame(animate);
        }
    }
    useEffect(function () {
        requestAnimationFrame(animate);
        return function () {
            shouldAnimateRef.current = false;
        };
    }, []);
    return (_jsx("div", __assign({ className: twMerge('flex flex-col items-center md:items-end', className) }, { children: text.map(function (item, index) { return (_jsx("span", __assign({ style: {
                marginTop: (index !== 0 && "-".concat(lineHeight, "px")) || '0px',
                transform: "translateY(".concat(translateValues[index] * lineHeight, "px)\n                        scaleY(").concat(scaleValues[index], ")"),
            } }, { children: _jsx("h3", __assign({ style: {
                    opacity: lerp(opacityMask, 1, scaleValues[index] || 0),
                    lineHeight: "".concat(lineHeight, "px"),
                }, className: "font-display md:text-md-head-d text-md-head-m" }, { children: item })) }), index)); }) })));
}
export default Tumbler;
